import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type PhoneOutgoingIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const PhoneOutgoingIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: PhoneOutgoingIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Phone outgoing'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <polyline
        points='17 1 21 5 17 9'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <line
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        x1='21'
        x2='11'
        y1='5'
        y2='5'
      />
    </svg>
  )
}
